export default {
  styleOverrides: {
    root: {
      margin: 0,
    },
  },
};
